import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

import {
    Seo,
    Spacer,
    CallToAction
} from "../../components"

const OnSiteITService = () => {


    return (
        <main>

            <Spacer height={120} />

            <section className="container">
                <div className="row h-100 d-flex align-items-center">
                    <div className="col-12 text-center text-danger bg-dark" style={{ padding: '120px 0px' }} data-augmented-ui="border tr-2-clip-x  bl-2-clip-x  tl-clip br-clip b-clip-x" >
                        <div className="hero-background">
                            <StaticImage className="h-100 w-100" src="../../images/pexels-brett-sayles-2881229.jpg" alt="Networking Equipment" width={1080} />
                        </div>
                        <div className="py-5">
                            <h2 className="text-white">D3VL</h2>
                            <h1 className="display-1 mb-3 text-white">On Premise IT</h1>
                        </div>
                    </div>
                </div>
            </section>

            <Spacer height={60} />

            <section className="container">
                <p>
                    We offer on-site IT management services to help you and your business get the most out of your technology investments. Resolving technical issues quickly and efficiently, Our team of IT professionals are trained and experienced in a wide range of technologies and are ready to provide expert support and assistance on an as-needed basis.
                </p>
                <p>
                    One of the main benefits of our on-site IT management services is that we help minimize downtime and ensure that systems are running smoothly. When technical issues arise, our team can quickly diagnose and resolve problems, helping you to avoid extended periods of downtime that can impact productivity and profitability.
                </p>
                <p>
                    In addition to minimizing downtime, our on-site IT management services also provide a higher level of security. By regularly monitoring systems and identifying potential vulnerabilities, we can help protect against cyber threats and keep business data secure. We also provide training and guidance to help employees understand how to protect themselves and their company from online threats.
                </p>
                <p>
                    Our on-site IT management services can also help businesses save time and money by providing expert technical support on an as-needed basis. Rather than having to hire and manage in-house IT staff, businesses can outsource their IT needs to our team, reducing the burden on their internal resources.
                </p>
                <p>
                    Our on-site IT management services are a valuable way for you to get the most out of your technology investments and protect against potential threats. By partnering with our experienced team, you can enjoy greater peace of mind and focus on what you do best.
                </p>

            </section>

            <Spacer height={60} />

            <section className="container">
                <div className="row">
                    <div className="col-12 col-xl-6 mb-3" >
                        <StaticImage className="w-100 rounded" src="../../images/pexels-polina-zimmerman-3747481.jpg" alt="Web Development" height={600} />
                    </div>
                    <div className="col-12 col-xl-6">
                        <h2 className="fancy-title">What We Do</h2>
                        <p>
                            <b>Equipment Maintenance:</b> Our team of certified technicians can perform routine maintenance on your equipment to keep it running smoothly and prevent any potential issues from arising. This includes hardware inspections, component replacements, and performance optimizations.
                        </p>
                        <p>
                            <b>Purchase Recommendation:</b> Our experts can help you make informed decisions when it comes to purchasing new equipment, whether it's hardware, software, or anything in between. We will take into consideration your budget, current setup, and future plans to recommend the best options for your organization.
                        </p>

                        <p>
                            <b>Software Updates:</b> Keeping your software up-to-date is critical to maintaining the security and performance of your IT systems. Our team can handle all of your software updates, from operating systems to applications, to ensure that everything is current and running smoothly.
                        </p>

                        <p>
                            <b>General Support:</b> Our on-site IT support services are designed to help you troubleshoot any issues that arise with your equipment and software. Whether you're experiencing a technical problem or just need some advice, our team is here to help you resolve it quickly and effectively.
                        </p>

                        <p>
                            <b>Other:</b> In addition to the services listed above, we can also provide customized support for your organization. Whether it's setting up new equipment, configuring networks, or anything in between, our team is here to help.
                        </p>
                    </div>
                </div>
            </section>


            <Spacer height="40" />
            <CallToAction />
            <Spacer height="50" />
        </main>
    )
}

export default OnSiteITService

export const Head = () => <>
    <Seo
        title="D3VL - On Site IT Solutions"
        description="We offer on-site IT management services to help you and your business get the most out of your technology investments. Resolving technical issues quickly and efficiently, Our team of IT professionals are trained and experienced in a wide range of technologies and are ready to provide expert support and assistance on an as-needed basis."
        path="/service/on-premise-it/"
    />
</>